import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MalasiaImg from "../assets/Ellipse 48.png";
import SrilankaImg from "../assets/Ellipse 49.png";
import ParisImg from "../assets/Ellipse 50.png";
import BarcelonaImg from "../assets/Ellipse 51.png";
import RomeImg from "../assets/Ellipse 52.png";
import TokyoImg from "../assets/Ellipse 50.png"; // New image for Tokyo

const mockData = [
  { id: 1, name: "MALAYSIA", imgSrc: MalasiaImg, duration: "5N 6N" },
  { id: 2, name: "SRILANKA", imgSrc: SrilankaImg, duration: "5N 3N" },
  { id: 3, name: "PARIS", imgSrc: ParisImg, duration: "4N 6N" },
  { id: 4, name: "BARCELONA", imgSrc: BarcelonaImg, duration: "7N 4N" },
  { id: 5, name: "ROME", imgSrc: RomeImg, duration: "2N 6N" },
  { id: 6, name: "TOKYO", imgSrc: TokyoImg, duration: "3N 5N" } // New city
];

const YourRecentSearch = () => {
  const [visibleCities, setVisibleCities] = useState(mockData.slice(0, 5));
  const [activeCity, setActiveCity] = useState(null);
  
  // Function to handle city click
  const handleCityClick = (cityName, id) => {
    setActiveCity(id);
  };

  const handleNextClick = () => {
    setVisibleCities((prevCities) => {
      const newCities = [...prevCities];
      const nextCity = mockData.find(city => !prevCities.includes(city)) || mockData[0];
      newCities.shift();
      newCities.push(nextCity);
      return newCities;
    });
  };

  return (
    <>
      <style>
        {`
          .responsive-container {
            top: 5vw;
            width: 100%;
            max-width: 1800px;
            margin-top: 20px;
          }

          .responsive-header {
            padding: 10px 20px;
            text-align: left;
          }

          /* Responsive adjustments */
          @media (max-width: 1024px) {
            .responsive-container {
              width: 100%;
              margin-top: 10vw;
            }
            .city-image {
              width: 120px !important;
            }
          }

          @media (max-width: 768px) {
            .responsive-container {
              margin-top: 5vw;
              width: 90%;
            }
            .city-image {
              width: 100px !important;
            }
          }

          @media (max-width: 576px) {
            .container-recent {
              margin-top: 50px;
              margin-left: auto;
              margin-right: auto;
              text-align: center;
            }

            .responsive-container {
              width: 85%;
              margin-top: 5vw;
              position: relative;
            }

            .city-image {
              width: 80px !important;
            }

            .responsive-header {
              padding: 5px;
              text-align: left;
            }
          }

          /* Hover effect */
          .city-image {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            width: 140px;
          }

          .city-image:hover {
            transform: scale(1.1);
            box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.25);
          }

          /* Clicked effect */
          .clicked {
            border: 3px solid;
            border-image-source: linear-gradient(90deg, #00FF66 0%, #936FE0 100%);
            border-image-slice: 1;
          }

          @media screen and (max-width: 425px) {
            .container-recent {
              margin-top: 100px;
              margin-left: auto;
              margin-right: auto;
            }

            .recent-cards {
              padding-left: 5vw;
              padding-top: 2vw;
            }

            .responsive-container {
              position: relative;
              top: 0;
            }
          }

          @media only screen and (max-width: 768px) {
            .responsive-header {
              display: flex;
              flex-direction: column;
              align-items: left;
              text-align: left;
            }

            .right-arrow button {
              margin-left: 0;
            }
          }
        `}
      </style>

      <div className="container container-recent rounded-3 text-black position-relative pt-4 responsive-container">
        <div className="text-white container mb-3 responsive-header d-flex flex-column align-items-left">
          <div>
            <h3 style={{ color: "#321E5D", fontWeight: "800", fontFamily: "Roboto" }}>
              Recent <span style={{ color: "rgba(139, 9, 219, 1)", fontFamily: "Roboto" }}>Searches</span>
            </h3>
            <p style={{ color: "rgba(50, 30, 93, 1)", fontFamily: "Roboto", fontWeight: "400", fontSize: "14px" }}>
              What Are You Waiting For? Grab These Now.
            </p>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-center">
          <div className="d-flex flex-row flex-wrap recent-cards" style={{ gap: "85px", marginLeft: "-170px" }}>
            {visibleCities.map((place) => (
              <div key={place.id} onClick={() => handleCityClick(place.name, place.id)} className="text-center">
                <img
                  src={place.imgSrc}
                  alt={place.name}
                  className={`city-image ${activeCity === place.id ? 'clicked' : ''}`}
                  style={{
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                />
                <div>
                  <p className="mt-2" style={{ fontSize: "15px", color: "rgba(50, 30, 93, 1)" }}>{place.name}</p>
                  <p style={{ marginTop: '0px', marginBottom: '2px', fontSize: "15px", color: "rgba(50, 30, 93, 1)" }}>{place.duration}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="d-flex right-arrow justify-content-center align-items-center mb-5 p-3">
            <button
              onClick={handleNextClick}
              style={{
                width: "43px",
                height: "43px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer"
              }}
              className="border-0"
            >
              <span className="fw-bold p-2" style={{ fontSize: "56px", color: "black", borderRadius: "20px" }}>&rsaquo;</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default YourRecentSearch;
